import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Row, Col, Form } from 'antd';
import { Input } from 'ui/styled';
import { Label } from 'pages/Ticket/styled';
import { Issue } from 'generated/types';
import EnumSelect from 'components/EnumSelect';
import MemberAdditionSection from './MemberAdditionSection';
var TextArea = Input.TextArea;
var Item = Form.Item;
var EligibilityInquiryFields = function (_a) {
    var form = _a.form, _b = _a.isTicketContext, isTicketContext = _b === void 0 ? false : _b;
    var eligibilityIssues = Form.useWatch('eligibility_inquiry_issues_attributes', form);
    var showManualMemberAdd = eligibilityIssues === null || eligibilityIssues === void 0 ? void 0 : eligibilityIssues.some(function (issue) {
        return issue.issue_type === Issue.NewMemberToBeAdded;
    });
    var handleIssueTypesChange = function (values) {
        var selectedValues = Array.isArray(values) ? values : [values];
        var currentIssues = form.getFieldValue('eligibility_inquiry_issues_attributes') || [];
        return selectedValues.map(function (type) {
            var existingIssue = currentIssues.find(function (item) { return item.issue_type === type; });
            return (existingIssue === null || existingIssue === void 0 ? void 0 : existingIssue.id)
                ? { id: existingIssue.id, issue_type: type }
                : { issue_type: type };
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(Row, { children: _jsxs(Col, { span: 24, children: [_jsx(Label, { required: true, children: "Eligibility Issue Type" }), _jsx(Item, { name: "eligibility_inquiry_issues_attributes", rules: [
                                {
                                    required: true,
                                    message: 'Please select at least one issue type'
                                }
                            ], getValueFromEvent: handleIssueTypesChange, getValueProps: function (value) { return ({
                                value: (value === null || value === void 0 ? void 0 : value.map(function (item) { return item.issue_type; })) || []
                            }); }, children: _jsx(EnumSelect, { enum_name: "ELIGIBILITY_ISSUE", mode: "multiple", placeholder: "Select issue types", "data-test": "eligibilityInquiryIssueTypesSelect" }) })] }) }), _jsx(Row, { children: _jsxs(Col, { span: 24, children: [_jsx(Label, { required: true, children: "Description of the Issue" }), _jsx(Item, { name: "description", rules: [{ required: true, message: 'Please input description' }], children: _jsx(TextArea, { autoSize: { minRows: 3, maxRows: 6 }, placeholder: "Enter description of the issue", "data-test": "eligibilityInquiryDescriptionTextarea" }) })] }) }), showManualMemberAdd && (_jsx(MemberAdditionSection, { isTicketContext: isTicketContext }))] }));
};
export default EligibilityInquiryFields;
